<template>
    <div id="footer" class="tc f5 w-100 mt2" >
        <div v-if="!mobile" class="desktop fw4 pb3 bg">
            <div class="dib tracked w-20-ns f5 tl">
                <div><img class="" :src="require(`@/assets/${info.logo}`)" /></div>
            </div>
            <div class="dib w-50-ns f5">
                <div class="dt w-100 b center tc h3 center">
                    <div class="pv1 mt2"><a class="link" :href="info.tel"><i class="fa fa-phone mr3" style="font-size:18px"/>{{info.phone}}</a></div>
                    <div class="pv1"><a class="link" :href="info.mail"><i class="fa fa-envelope-o mr3"/> {{info.email}}</a></div>
                    <div class="pv1"><a class="link" :href="info.directions" target="_blank"><i class="fa fa-map-marker mr3"/> {{info.address}}</a></div>
                    <div class="tc small mt2"><a class="link" href="https://reah.me">Developed by Miyara © ProSource Supply 2020</a></div>
                </div>
            </div>
            <div class="dib w-20">
                <div class="dt h3 fr">
                    <div class="dtc v-mid">                  
                        <a class="ph3" :href="info.yelp" target="_blank"><div class="dib w-20"><img class="" :src="require(`@/assets/${info.yelpLogo}`)" /></div></a>
                        <a class="ph3" :href="info.map" target="_blank"><div class="dib w-20"><img class="" :src="require(`@/assets/${info.googleLogo}`)" /></div></a>
                    </div>
                </div>
            </div>
        </div>
        <div class="fw4 bg" v-else>
            <div class="pa1 ps-blue b">
                <div class="dt center mb2 mt2 f4 tl">
                    <!-- <div class="b tracked">ProSource Supply</div> -->
                    <div class="pa1 f5"><a class="link" :href="info.tel"><i class="fa fa-phone mr2" style="font-size:18px"/>{{info.phone}}</a></div>
                    <div class="pa1 f5"><a class="link" :href="info.mail"><i class="fa fa-envelope-o mr1"/> {{info.email}}</a></div>
                    <div class="pa1 f5"><a class="link" :href="info.directions" target="_blank"><i class="fa fa-map-marker mr2"/> {{info.address}}</a></div>
                    <div class="tc small-mbl mt3"><a class="link" href="https://reah.me">Developed by Miyara © ProSource Supply 2020</a></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Footer',
    props: ['site', 'info', 'mobile']
}
</script>

<style scoped>
.small {
    font-weight: 100;
    font-size: .7em;
}
a.link:hover {
  background-color: #0f376f;
  color: #fff;
  transition: ease .5s;
  padding: .25rem;
}
.small-mbl {
    font-weight: 100;
    font-size: .5em;
}
.small:hover {
    background-color: white !important;
    color: #0f376f !important;
}
.bg {
    /* background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)), url("https://images.unsplash.com/photo-1516541196182-6bdb0516ed27?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2134&q=80"); */
    background: #fff;
}

</style>